import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { CorporateFilters } from '../../components/CorporateFilters'
import { useCorporateListViewStore } from './CorporateListViewStore'

export type CorporateListViewActionsProps = {
  className?: string
}

export function CorporateListViewActions({ className }: CorporateListViewActionsProps) {
  const {
    state: { filters },
    actions: { setFilters },
  } = useCorporateListViewStore()
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.container)}>
      <CorporateFilters filters={filters} onChange={setFilters} />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
  },
  button: {
    textDecoration: 'none',
    marginLeft: spacing(2),
  },
}))
